module.exports = __webpack_public_path__ + "static/media/Bubbly_ios_3.d363749f.jpg";